export default {
  currency: 'EUR',
  tax_rate: 16,
  shippingMethod: {
    name: 'standard',
    price: 8600,
  },
  freeShipping: 15000,
};
